<ng-container *ngIf="!!(title$ | async); else noTitleContainer">
  <ng-template
    [ngTemplateOutlet]="infoTemplate"
    [ngTemplateOutletContext]="{
      items: items$ | async,
      disableActionButton: disableActionButton,
      hideActionButton: hideActionButton,
      actionButtonClicked: actionButtonClicked,
      actionButtonText: actionButtonText,
      showFullSin$: showFullSin$
    }"></ng-template>
</ng-container>

<hr *ngIf="!hideBottomDivider" [ngStyle]="{ 'margin-bottom': lastSection ? 0 : '2rem' }" />

<ng-template #noTitleContainer>
  <ng-template
    [ngTemplateOutlet]="noTitleTemplate"
    [ngTemplateOutletContext]="{
      items: items,
      hideActionButton: hideActionButton,
      disableActionButton: disableActionButton,
      actionButtonClicked: actionButtonClicked,
      actionButtonText: actionButtonText,
      showFullSin$: showFullSin$
    }"></ng-template>
</ng-template>

<ng-template
  #infoTemplate
  let-items="items"
  let-disableActionButton="disableActionButton"
  let-hideActionButton="hideActionButton"
  let-actionButtonClicked="actionButtonClicked"
  let-actionButtonText="actionButtonText"
  let-showFullSin$="showFullSin$">
  <div class="info">
    <div class="info-header">
      <div class="container-label">{{ title$ | async }}</div>
      <button
        *ngIf="!hideActionButton"
        [class.disabled]="disableActionButton"
        [disabled]="disableActionButton"
        class="primary-paddingless-text-button"
        (click)="actionButtonClicked.emit()">
        {{ actionButtonText }}
      </button>
    </div>
  </div>
  <div class="info-container">
    <ng-container *ngFor="let item of items; trackBy: trackByIndex">
      <div *ngIf="item?.isSpacer; else infoItem" aria-hidden="true"></div>
      <ng-template #infoItem>
        <div class="data-container" [ngClass]="{ 'w-100': item?.fullWidth }">
          <span class="info-label">{{ item?.infoLabel }}</span>
          <div class="d-flex justify-content-between">
            <ng-container *ngTemplateOutlet="nameLabelTemplate; context: { item: item, showFullSin$: showFullSin$ }" />
            <div
              class="item-tooltip-container"
              *ngIf="item?.tooltip"
              [ngbTooltip]="item?.tooltip"
              [triggers]="'hover focus click'">
              <img class="item-tooltip" [src]="'assets/icons/dark/CircleQuestion.svg'" alt="" />
            </div>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #noTitleTemplate
  let-items="items"
  let-disableActionButton="disableActionButton"
  let-hideActionButton="hideActionButton"
  let-actionButtonClicked="actionButtonClicked"
  let-actionButtonText="actionButtonText"
  let-showFullSin$="showFullSin$">
  <div class="d-flex flex-column">
    <ng-container *ngFor="let item of items; let first = first">
      <div
        *ngIf="first && separateFirstItem"
        class="separate-first-row align-items-center"
        [style.margin-bottom.rem]="2"
        [style.grid-template-columns]="gridTemplateColumns$ | async">
        <div class="data-container separate-first-item" [style.margin-top.rem]="0">
          <span class="info-label">{{ item?.infoLabel }}</span>
          <ng-container *ngTemplateOutlet="nameLabelTemplate; context: { item: item, showFullSin$: showFullSin$ }" />
        </div>
        <div class="d-flex gap-3 justify-content-end separate-first-actions">
          <div *ngIf="!!item?.statusPill">
            <app-status-pill [statusPill]="item.statusPill" />
          </div>
          <button
            *ngIf="!hideActionButton"
            [disabled]="disableActionButton"
            class="primary-paddingless-text-button"
            (click)="actionButtonClicked.emit()">
            {{ actionButtonText }}
          </button>
        </div>
      </div>
    </ng-container>
    <div
      [class]="twoColLayout ? 'item-container-two-col' : 'item-container'"
      [style.grid-template-columns]="twoColLayout ? null : (gridTemplateColumns$ | async)">
      <ng-container *ngFor="let item of items; let first = first; trackBy: trackByIndex">
        <ng-container *ngIf="!first || !separateFirstItem">
          <div *ngIf="item?.isSpacer; else noTitleInfoItem" aria-hidden="true"></div>
          <ng-template #noTitleInfoItem>
            <div
              [class]="twoColLayout ? 'two-col-data-container' : 'data-container'"
              [ngClass]="{ 'w-100': item?.fullWidth && !twoColLayout }">
              <span class="info-label">{{ item?.infoLabel }}</span>
              <ng-container
                *ngTemplateOutlet="nameLabelTemplate; context: { item: item, showFullSin$: showFullSin$ }" />
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
      <div *ngIf="!hideActionButton && !separateFirstItem" class="column-action-button">
        <button class="primary-paddingless-text-button" (click)="actionButtonClicked.emit()">
          {{ actionButtonText }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nameLabelTemplate let-item="item" let-showFullSin$="showFullSin$">
  <div class="name-label justify-content-start gap-3">
    <div
      [ngClass]="{ clickable: !!item?.url }"
      [class.sin-number]="item?.isSinNumber"
      (click)="navigateToLink(item?.url)">
      {{
        item?.isSinNumber
          ? (item?.value | maskSinNumber : (showFullSin$ | async) ?? false : item?.isSinNumber)
          : item?.value ?? '-'
      }}
    </div>
    <div *ngIf="item?.isSinNumber && item?.canViewFullSin">
      <button (click)="toggleSin($event)" class="eye">
        <img [src]="sinButtonIcon$ | async" alt="eye-icon" i18n-alt />
      </button>
    </div>
  </div>
</ng-template>
